__webpack_require__.p = "https://ads.wpcdn.pl/release-v1.470.0/public-desktop/";